var render, staticRenderFns
import script from "./InfluencerSettingsChannelsPage.vue?vue&type=script&lang=js"
export * from "./InfluencerSettingsChannelsPage.vue?vue&type=script&lang=js"
import style0 from "./InfluencerSettingsChannelsPage.vue?vue&type=style&index=0&id=4832d598&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports